import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmPasswordControlDirective } from './directives/confirm-password-control.directive';
import { EmailVerifier } from './directives/email-verifier.directive.';
import { ForbiddenValidatorDirective } from './directives/forbiddenNameValidator';
import { IdentificationNoControlDirective } from './directives/identification-no-control.directive';
import { IsInRangeValidator } from './directives/IsInRangeValidator';
import { IsNumberValidator } from './directives/IsNumberValidator';
import { PatternValidator } from './directives/PatternValidator';
/* Custom Directive Begin */
import { PhoneControlDirective } from './directives/phone-control.directive';
import { SistekEmailPattern } from './directives/sistek-email-pattern.directive';
import { UsernameServerControlDirective } from './directives/username-server-control.directive';
import { UsernameVerifier } from './directives/username-verifier.directive';

const DIRECTIVES = [
	PhoneControlDirective,
	SistekEmailPattern,
	UsernameServerControlDirective,
	ConfirmPasswordControlDirective,
	IdentificationNoControlDirective,
	UsernameVerifier,
	EmailVerifier,
	ForbiddenValidatorDirective,
	IsInRangeValidator,
	IsNumberValidator,
	PatternValidator,
];

@NgModule({
	imports: [CommonModule, TranslateModule],
	declarations: [...DIRECTIVES],
	exports: [...DIRECTIVES],
	providers: [],
})
export class ValidatorsModule {}
